class PaginationNext extends HTMLElement {
    constructor() {
      super();
    }
    updateDOM(url) {
      const section = this.closest("[data-section-id]");
      const loadingText =this.getAttribute("loading-text");
      this.innerHTML = loadingText;
      this.style.pointerEvents = 'none';
      if (!!section) {
        section.classList.add("loading");
        const section_id = section.dataset.sectionId;
        if (!!section_id && !!url) {
          const fetch_url = new URL(url, location.origin);
          fetch_url.searchParams.set("section_id", section_id);
          fetch(fetch_url.href, {
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" },
            method: "GET",
          })
          .then((response) => response.text())
          .then((data) => {
            const template = document.createElement("template");
            template.innerHTML = data.trim();
            const productGrid = section.querySelector('[product_collection_grid]');
            const newProducts = template.content.querySelectorAll('[product_collection_grid] product-block');
            
            productGrid.append(...newProducts);
            const pagination_button_old = section.querySelector('[collection_pagination]');
            const pagination_button_new = template.content.querySelector('[collection_pagination]');
            if(!!pagination_button_old) {
              if(!!pagination_button_new) {
                pagination_button_old.replaceWith(pagination_button_new);
              } else {
                pagination_button_old.remove();
              }
            }
            if (!!section) {
              section.classList.remove("loading");
            }
          })
          .catch(function (err) {
            if (!!section) {
              section.classList.remove("loading");
            }
            console.error(err);
          });
        }
      }
    }
    connectedCallback() {
      this.addEventListener("click", () => {
        const url = this.getAttribute("update-url");
        if (!!url) {
          this.updateDOM(url);
        }
      });
    }
  }
  customElements.define("pagination-next", PaginationNext);
